import styled from "styled-components";


export const FooterContent = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;  
  justify-content: end;
`;